




import { defineComponent, PropType } from 'vue';
import { PostModel } from '../../../shared/models/post.model';
import MediaAttachmentsPreview from '../../../shared/components/MediaAttachmentsPreview.vue';
import { parentTypes } from '../../../shared/enums/parentTypes';

export default defineComponent({
  name: 'PostAttachments',
  components: { MediaAttachmentsPreview },
  props: {
    post: { type: Object as PropType<PostModel>, required: true },
  },
  setup() {
    return {
      parentTypes,
    };
  },
});
